.grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: var(--space-6); }
.heading { margin-bottom: var(--space-2); font-size: var(--text-sm); font-weight: var(--weight-semibold); color: var(--color-text); }
.list { margin: 0; }
.row { display: flex; align-items: center; justify-content: space-between; gap: var(--space-3); min-height: 32px; border-bottom: 1px solid var(--color-border); }
.row dt { color: var(--color-text-secondary); font-size: var(--text-sm); }
.keys { display: flex; align-items: center; gap: var(--space-1); margin: 0; }
.keyWrap { display: inline-flex; align-items: center; gap: var(--space-1); }
.then { color: var(--color-text-muted); font-size: var(--text-2xs); }
.note { margin-top: var(--space-5); color: var(--color-text-muted); font-size: var(--text-sm); }
